import { gql, useQuery } from '@apollo/client';

export const GET_COMPANY_POSITIONS = gql`
  query ($companyId: String!, $deleted: Boolean) {
    getCompanyPositions(companyId: $companyId, deleted: $deleted) {
      _id
      name
      deleted
    }
  }
`;

export const useGetCompanyPositions = ({
  companyId,
  deleted,
}: {
  companyId?: String;
  deleted?: boolean;
}) => {
  const { data, loading } = useQuery(GET_COMPANY_POSITIONS, {
    variables: { companyId, deleted },
    skip: !companyId,
  });

  const companyPositions = data?.getCompanyPositions || [];

  return {
    loading,
    companyPositions,
  };
};
